<template>
  <div class='pre-charges'>
    <pager v-on:pagination="loadData" v-bind:items='pre_charges || []'></pager>
    <div class="">
      <table class='table table-sm table-hover'>
        <thead>
          <tr>
            <th>公司</th>
            <th>操作/操作人</th>
            <th>充值时间</th>
            <th>申请人</th>
            <th>充值金额</th>
            <th>充值后账户余额</th>
            <th>充值方式</th>
            <th>备注</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pre_charge of pre_charges" :class="{'table-success': pre_charge.approved === true, 'table-dark': pre_charge.approved === false }">
            <td nowrap>{{pre_charge.company.nickname}}</td>
            <td nowarp>
              <div v-if="pre_charge.approved !== null">
                <span v-if="pre_charge.approved === true">已核实({{pre_charge.approved_by}})</span>
                <span v-if="pre_charge.approved === false">已拒绝({{pre_charge.approved_by}})</span>  
              </div>
              <div v-else-if="(isAdmin && pre_charge.charge_amount < 0) || (isFinance && pre_charge.charge_amount > 0)">
                <button class="btn btn-primary btn-sm mx-2" @click="approvePreCharge(pre_charge.id, true)" v-if="pre_charge.approved === null">核实</button>
                <button class="btn btn-danger btn-sm mx-2" @click="approvePreCharge(pre_charge.id, false)" v-if="pre_charge.approved === null">拒绝</button>
              </div>
              <div v-else>
                待核实
              </div>
            </td>
            <td nowrap><local-time :time="pre_charge.created_at"></local-time></td>
            <td nowrap>{{pre_charge.user.nickname}}</td>
            <td>{{pre_charge.charge_amount}}元</td>
            <td>{{pre_charge.remained_amount}}元</td>
            <td nowrap>{{getPreChargeTypeDisplay(pre_charge.charge_type)}}</td>
            <td>{{pre_charge.notes}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Pager from './_partial/Pager'
import LocalTime from '@/components/_small/LocalTime'
import LoadDataMixin from '@/mixins/load_data'
import CompanyMixin from '@/mixins/company'
import RoleMixin from '@/mixins/role'
import {toQueryString} from '@/utils/tools'

function loadData () {
  // Make a request for a user with a given ID
  this.$http.doSpin()
  this.$http.get('/api/pre_charges' + location.search).then(response => {
    this.pre_charges = response.data.data
    this.$http.cancelSpin()
  })
  .catch(function (error) {
    this.$http.cancelSpin()
    console.log(error)
  })
}

function approvePreCharge(id, approved) {
  const username = prompt("请输入操作人名称")
  this.$http.post(`/api/pre_charges/${id}/approve`, {
    approved: approved,
    approved_by: username
  }).then(response => {
    this.loadData()
  })
}

export default {
  name: 'pre-charges',
  mixins: [CompanyMixin, LoadDataMixin, RoleMixin],
  data () {
    return {
      'pre_charges': []
    }
  },
  components: {
    Pager,
    LocalTime
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData,
    toQueryString,
    approvePreCharge
  }
}
</script>